// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"785e1447","186":"d7ac9b59","272":"b66a1732","372":"8cf937e9","377":"9fb1a9e2","738":"585f2fd8","841":"47c96779","851":"9d6b4695","856":"7f180e97"}[chunkId] + ".chunk.js";
};